import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cambioEstadoComercio'
})
export class CambioEstadoComercioPipe implements PipeTransform {

  transform(value: string, ...args: string[]): string {
    return value ? 'Activar' : 'Desactivar';
  }
}
